import React from 'react';
import { Outlet } from 'react-router-dom';
import AdminNavigationShadcn from '../navigation/AdminNavigationShadcn';
import { useAdminAccess } from '../../../Hooks/useAdminAccess';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../../../ui/card';
import '../../../admin.css';

/**
 * Admin Layout Component (shadcn/ui version)
 * Provides consistent layout for all admin pages with navigation
 * Migration-friendly: Can coexist with old AdminLayout
 */
const AdminLayoutShadcn = () => {
  const { hasAdminAccess } = useAdminAccess();

  if (!hasAdminAccess()) {
    return (
      <div className="admin-layout min-h-screen flex items-center justify-center bg-background">
        <Card className="w-full max-w-md">
          <CardHeader>
            <CardTitle>Access Denied</CardTitle>
            <CardDescription>
              You don't have permission to access the admin panel.
            </CardDescription>
          </CardHeader>
          <CardContent>
            <p className="text-sm text-muted-foreground">
              Please contact your administrator if you believe this is an error.
            </p>
          </CardContent>
        </Card>
      </div>
    );
  }

  return (
    <div className="admin-layout flex min-h-screen bg-background">
      {/* Sidebar Navigation */}
      <aside className="w-64 border-r bg-card">
        <AdminNavigationShadcn />
      </aside>

      {/* Main Content Area */}
      <main className="flex-1 overflow-auto">
        <div className="container mx-auto p-6">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default AdminLayoutShadcn;
